import { useEffect, useState } from "react";
import { Modal, Input, Button, message, Spin } from "antd";
import { connect } from "react-redux";
import {
  ACCOUNTABILITY_COPY_FIELDS,
  DEFAULT_ACCOUNTABILITY_COPY,
  mergeAccountabilityCopy,
} from "./accountabilityCopy";

const toSettings = (payload) =>
  mergeAccountabilityCopy(payload?.data?.data || payload?.data || payload || {});

const AccountabilityCopyModal = ({ open, onCancel, getSettings, saveSettings }) => {
  const [form, setForm] = useState(DEFAULT_ACCOUNTABILITY_COPY);
  const [loading, setLoading] = useState(false);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    if (!open) return;
    setLoading(true);
    getSettings({
      callback: (ok, payload) => {
        setForm(toSettings(ok ? payload : {}));
        setLoading(false);
        if (!ok) message.error("Could not load accountability copy");
      },
    });
  }, [open]);

  const handleSave = () => {
    setSaving(true);
    saveSettings({
      body: form,
      callback: (ok) => {
        setSaving(false);
        if (!ok) {
          message.error("Could not save accountability copy");
          return;
        }
        message.success("Accountability copy updated");
        onCancel();
      },
    });
  };

  return (
    <Modal
      open={open}
      onCancel={onCancel}
      title={
        <span className="text-[#0F1A24] text-[14px] font-bold font-inter">
          Edit Accountability Question
        </span>
      }
      footer={null}
      width={520}
      destroyOnClose
    >
      {loading ? (
        <div className="flex justify-center py-8">
          <Spin />
        </div>
      ) : (
        <div className="flex flex-col gap-3">
          {ACCOUNTABILITY_COPY_FIELDS.map(({ key, label, hint, rows }) => (
            <label key={key} className="flex flex-col gap-1">
              <span className="text-[12px] font-inter font-semibold text-[#0F1A24]">
                {label}
              </span>
              {hint ? (
                <span className="text-[11px] font-inter text-[#4A6074]">{hint}</span>
              ) : null}
              <Input.TextArea
                rows={rows}
                maxLength={500}
                value={form[key]}
                onChange={(e) => setForm((prev) => ({ ...prev, [key]: e.target.value }))}
              />
            </label>
          ))}
          <div className="flex justify-end gap-2 mt-2">
            <Button onClick={onCancel}>Cancel</Button>
            <Button
              className="bg-[#1A91FF] text-white"
              loading={saving}
              onClick={handleSave}
            >
              Save
            </Button>
          </div>
        </div>
      )}
    </Modal>
  );
};

const mapDispatchToProps = (dispatch) => ({
  getSettings: (details) =>
    dispatch(global.redux.action.learning_accountability.getSettings(details)),
  saveSettings: (details) =>
    dispatch(global.redux.action.learning_accountability.saveSettings(details)),
});

export default connect(null, mapDispatchToProps)(AccountabilityCopyModal);
